import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetPlaceCategoriesApiResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
        }),
    ),
});

type GetPlaceCategoriesApiResponse
    = ApiResponse<z.infer<typeof GetPlaceCategoriesApiResponseSchema>>
    | BaseError;

type GetPlaceCategoriesActionRequest = undefined

export const getPlaceCategories = createAsyncThunk<
    GetPlaceCategoriesApiResponse,
    GetPlaceCategoriesActionRequest
>(
    'PlacesPageActionsGetPlaceCategories',
    async () => apiInstance.get(
        '/place-categories',
        {},
        GetPlaceCategoriesApiResponseSchema,
    ),
);
